import styles from './Page.module.scss';

export interface IPageProps {
    children: any
}

export function Page(props: IPageProps) {
    return (<div className={styles.host}>{props.children}</div>);
}
